<template>
  <b-table
    class="actions-table"
    :data="actionValues"
    :checkable="false"
    backend-sorting
    :default-sort="[sortField, sortDirection]"
    @sort="onSort">
    <template slot-scope="props">
      <template v-for="item in props.row">
        <b-table-column
          v-if="columns.includes(item.label)"
          :key="item.label"
          :field="item.field"
          :label="item.label"
          :sortable="sortableFields.includes(item.field)"
          :centered="item.centered">
          <router-link v-if="item.link" :to="item.link">
            {{ item.value }}
          </router-link>
          <span v-else>{{ item.value }}</span>
        </b-table-column>
      </template>
    </template>
  </b-table>
</template>

<script>
import _ from 'lodash';
import actions from '@/mixins/actions';

export default {
  name: 'ActionsTable',
  mixins: [actions],
  props: {
    actions: {
      type: Array,
      required: true,
    },
    sortField: {
      type: String,
      required: true,
    },
    sortDirection: {
      type: String,
      required: true,
    },
    onSort: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      columns: [
        'Name',
        'Description',
        'Created',
        'Modified',
      ],
      sortableFields: [
        'name',
        'created',
        'updated',
      ],
    };
  },
  computed: {
    actionValues() {
      return _.map(this.actions, a => this.keyValues(a));
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

div.actions-table {
  th.date, td.date {
    width: $table-date-width;
  }
}

</style>
